import React from "react";
import {getMode} from "../../state/ethereal/selectors";
import {useDispatch, useSelector} from "react-redux";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import {ActionCreators as EtherealActionCreators} from "../../state/ethereal/actions";
import { useCase } from '../../db/hooks';

export default ({caseId}) => {
    let mode = useSelector(getMode);
    const { caseData } = useCase(caseId);
    const showSwitch = caseData?.numberOfAlternates > 0;
    let dispatch = useDispatch();

    const handleToggleMode = () => {
        let newMode = mode === "jury-box" ? "alternates" : "jury-box";
        dispatch(EtherealActionCreators.setMode(newMode));
    };

    if (showSwitch) {
        return <FormControlLabel
            key={'mode-switch'}
            style={{marginLeft: "5px"}}
            control={
                <Switch checked={mode === "alternates"}
                        onChange={handleToggleMode}
                        name={'mode'}/>
            }
            label={'Alternates'}/>
    }
    return <div key={'mode-switch'}/>
};
